import type { LearnFAQ } from "@/pages/learn/learnShared";
import {
  makeEsArticle,
  esSaintRelated,
  type EsArticleInput,
} from "./learnFactoryEs";

const reviewBlock = {
  writtenBy: "Neuro Wellness TMS Centers of America",
  reviewedBy: "Daniel Pietras, MD",
  published: "November 3, 2026",
  lastReviewed: "November 3, 2026",
  lastUpdated: "November 3, 2026",
};

const faqs: LearnFAQ[] = [
  {
    question: "¿Puedo trabajar durante la semana de SAINT®?",
    answer:
      "La mayoría de los pacientes no trabajan durante la semana de SAINT®. Cada día incluye aproximadamente 10 sesiones con descansos de aproximadamente 50 minutos, por lo que el paciente debe estar en la clínica la mayor parte del día.",
  },
];

export const esCanWorkDuringWeek = makeEsArticle({
  slug: "can-i-work-during-saint-tms-treatment-week",
  title: "¿Puedo trabajar durante la semana de SAINT®?",
  description:
    "La mayoría de los pacientes no trabajan durante la semana de SAINT®, ya que cada día requiere estar en la clínica la mayor parte del día.",
  h1: "¿Puedo trabajar durante la semana de SAINT®?",
  breadcrumbLabel: "Trabajar durante la semana de SAINT®",
  shortAnswer:
    "La mayoría de los pacientes no trabajan durante la semana de SAINT®. Cada día incluye aproximadamente 10 sesiones con descansos de aproximadamente 50 minutos entre ellas, por lo que el paciente debe estar en la clínica la mayor parte de cada día. Como toda la semana se completa en cinco días consecutivos, muchas personas programan una semana de permiso del trabajo. La reincorporación laboral se analiza en la consulta.",
  keyTakeaways: [
    "La mayoría de los pacientes no trabajan durante la semana de SAINT®.",
    "Cada día incluye unas 10 sesiones con descansos de ~50 minutos.",
    "El paciente debe estar en la clínica la mayor parte del día.",
    "La semana se completa en cinco días consecutivos.",
    "La reincorporación laboral se analiza en la consulta.",
  ],
  sections: [
    {
      heading: "El ritmo diario",
      paragraphs: [
        "Cada día de tratamiento de SAINT® incluye aproximadamente 10 sesiones de estimulación, cada una de unos minutos, con descansos de aproximadamente 50 minutos entre sesiones. El paciente permanece despierto y alerta pero debe permanecer en la clínica la mayor parte del día.",
      ],
    },
  ],
  faqs,
  sources: [],
  relatedLinks: esSaintRelated,
  reviewBlock,
} satisfies EsArticleInput);
